import { signal } from '@preact/signals';

export const isColonyLost = signal(false);

export const setColonyLost = (): void => {
  isColonyLost.value = true;
};

export const clearColonyLost = (): void => {
  isColonyLost.value = false;
};
